<style src="./GuardConfig.scss" lang="scss"></style>
<template>
  <div class="GuardConfig wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="mail-box-header">
          <h2>Arquivo</h2>

          <div class="row">
            <div class="form-group col-lg-4">
              <label>Prefixo</label>
              <input
                type="text"
                class="form-control"
                v-model="form.fileName.prefix"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Lote Atual</label>
              <input
                type="text"
                class="form-control"
                v-model="form.fileName.currentLot"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="mail-box-header">
          <h2>Cabeçalho</h2>

          <div class="row">
            <div class="form-group col-lg-4">
              <label>Tipo</label>
              <input
                type="text"
                class="form-control"
                v-model="form.header.tipo"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Código da Prestadora</label>
              <input
                type="text"
                class="form-control"
                v-model="form.header.prestadoraCode"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Nome da Prestadora</label>
              <input
                type="text"
                class="form-control"
                v-model="form.header.prestadoraName"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Versão do Layout</label>
              <input
                type="text"
                class="form-control"
                v-model="form.header.layoutVersion"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="mail-box-header">
          <h2>Linha</h2>

          <div class="row">
            <div class="form-group col-lg-4">
              <label>Tipo</label>
              <input type="text" class="form-control" v-model="form.row.tipo" />
            </div>
            <div class="form-group col-lg-4">
              <label>Último AIT</label>
              <input
                type="text"
                class="form-control"
                v-model="form.row.lastAIT"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Prefixo do AIT</label>
              <input
                type="text"
                class="form-control"
                v-model="form.row.AITPrefix"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Enquadramento Padrão</label>
              <input
                type="text"
                class="form-control"
                v-model="form.row.defaultEnquadramento"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Código do Agente Padrão</label>
              <input
                type="text"
                class="form-control"
                v-model="form.row.defaultAgentCode"
              />
            </div>
            <div class="form-group col-lg-4">
              <label>Observação Padrão</label>
              <input
                type="text"
                class="form-control"
                v-model="form.row.defaultObservation"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="mail-box-header">
          <button type="button" @click="save" :disabled="isDisabled">
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { toast } from '@/plugins/toast';
export default {
  name: 'GuardConfig',
  data() {
    return {
      isDisabled: false,
      form: {
        fileName: {
          prefix: '',
          currentLot: 0,
        },
        header: {
          tipo: '',
          prestadoraCode: '',
          prestadoraName: '',
          layoutVersion: '',
        },
        row: {
          tipo: '',
          lastAIT: 0,
          AITPrefix: '',
          defaultEnquadramento: '',
          defaultAgentCode: '',
          defaultObservation: '',
        },
      },
    };
  },
  mounted() {
    this.loadGuardConfig();
  },
  methods: {
    async loadGuardConfig() {
      const guardConfig = await this.$store.dispatch(
        'GUARD-REQUEST/GetGuardConfig',
      );
      this.form.fileName = guardConfig.config.fileName;
      this.form.header = guardConfig.config.header;
      this.form.row = guardConfig.config.row;
    },
    async save() {
      this.isDisabled = true;
      try {
        await this.$store.dispatch(
          'GUARD-REQUEST/UpdateGuardConfig',
          this.form,
        );
        toast.success('Salvo com sucesso');
      } catch (error) {
        toast.error('Não foi possível salvar');
      } finally {
        this.isDisabled = false;
      }
    },
  },
};
</script>
